/* 03-11: elk contactformulier stuurt ook een kopie naar de app OLK Aanvragen, die hem als 'Aanvraag' in de
   Shopify-admin zet (Inhoud > Metaobjecten > Aanvragen). Het formulier zelf en de mail naar info@ blijven gewoon
   werken; sendBeacon wacht niet en houdt het versturen dus niet op. Luistert in de bubbelfase, zodat eigen
   submit-handlers (zoals de regels van de projectaanvraag) eerst hun velden vullen. Niet afhaken op
   defaultPrevented: Shopify's eigen spamcheck houdt elk contactformulier tegen en verstuurt het daarna zelf.
   Dubbele kopieën vangt de app af (zelfde persoon, soort en bericht op één dag = één rij). */
document.addEventListener('submit', function (e) {
  var f = e.target;
  if (!f || !f.querySelector || !f.querySelector('input[name="form_type"][value="contact"]')) return;
  if (!navigator.sendBeacon) return;
  try {
    var d = new FormData(f);
    d.delete('form_type'); d.delete('utf8');
    d.append('_pagina', location.href);
    navigator.sendBeacon('https://olk-aanvragen.netlify.app/api/aanvraag', d);
  } catch (x) {}
});
